/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_NetInputs */

const vi_cashflow_net = /** @type {(inputs: Cashflow_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng tiền ròng (net)`)
};

/**

* @param {Cashflow_NetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_net = /** @type {((inputs?: Cashflow_NetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_NetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_net(inputs)
});